module.exports = require("./bem.js");